"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Setting2Outlined = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.Setting2Outlined = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M8 5.33333C6.52724 5.33333 5.33333 6.52724 5.33333 8C5.33333 9.47276 6.52724 10.6667 8 10.6667C9.47276 10.6667 10.6667 9.47276 10.6667 8C10.6667 6.52724 9.47276 5.33333 8 5.33333ZM6.66667 8C6.66667 7.26362 7.26362 6.66667 8 6.66667C8.73638 6.66667 9.33333 7.26362 9.33333 8C9.33333 8.73638 8.73638 9.33333 8 9.33333C7.26362 9.33333 6.66667 8.73638 6.66667 8Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }),
            react_1.default.createElement("path", { d: "M8.625 0.869819C8.23825 0.646527 7.76175 0.646527 7.375 0.869819L2.13758 3.89364C1.75083 4.11693 1.51258 4.52959 1.51258 4.97618V11.0238C1.51258 11.4704 1.75083 11.8831 2.13758 12.1064L7.375 15.1302C7.76175 15.3535 8.23825 15.3535 8.625 15.1302L13.8624 12.1064C14.2492 11.8831 14.4874 11.4704 14.4874 11.0238V4.97618C14.4874 4.52959 14.2492 4.11693 13.8624 3.89364L8.625 0.869819ZM3.01258 10.8795V5.12051L8 2.24103L12.9874 5.12051V10.8795L8 13.759L3.01258 10.8795Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }));
    },
    name: 'setting_2_outlined',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M8 5.33333C6.52724 5.33333 5.33333 6.52724 5.33333 8C5.33333 9.47276 6.52724 10.6667 8 10.6667C9.47276 10.6667 10.6667 9.47276 10.6667 8C10.6667 6.52724 9.47276 5.33333 8 5.33333ZM6.66667 8C6.66667 7.26362 7.26362 6.66667 8 6.66667C8.73638 6.66667 9.33333 7.26362 9.33333 8C9.33333 8.73638 8.73638 9.33333 8 9.33333C7.26362 9.33333 6.66667 8.73638 6.66667 8Z', 'M8.625 0.869819C8.23825 0.646527 7.76175 0.646527 7.375 0.869819L2.13758 3.89364C1.75083 4.11693 1.51258 4.52959 1.51258 4.97618V11.0238C1.51258 11.4704 1.75083 11.8831 2.13758 12.1064L7.375 15.1302C7.76175 15.3535 8.23825 15.3535 8.625 15.1302L13.8624 12.1064C14.2492 11.8831 14.4874 11.4704 14.4874 11.0238V4.97618C14.4874 4.52959 14.2492 4.11693 13.8624 3.89364L8.625 0.869819ZM3.01258 10.8795V5.12051L8 2.24103L12.9874 5.12051V10.8795L8 13.759L3.01258 10.8795Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
